import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { queryProgressService } from '../services/queryProgressService';

export const trackProgress = createAsyncThunk(
  'queryProgress/trackProgress',
  async ({ sessionId }, { dispatch }) => {
    queryProgressService.trackProgress(sessionId, (progress) => {
      dispatch(setProgress(progress));
    });
  }
);

const queryProgressSlice = createSlice({
  name: 'queryProgress',
  initialState: {
    progress: null,
  },
  reducers: {
    setProgress: (state, action) => {
      state.progress = action.payload;
    },
  },
});

export const { setProgress } = queryProgressSlice.actions;
export default queryProgressSlice.reducer;
